module.exports = __webpack_public_path__ + "static/media/managment.ab67b49b.jpg";